import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/pages/index.scss';
import App from './App';
// Import the Theme Contexts
import { PremiumHistoryProvider } from "./contexts/PremiumHistory";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PremiumHistoryProvider>
    <App />
  </PremiumHistoryProvider>
);
